import { FC } from "react"
interface ChevronRightProps {
    width?: number
    height?: number
}
const ChevronRight: FC<ChevronRightProps> = ({ width = 7, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.894531 1L5.79003 5.8955L0.894531 10.791" stroke="black" />
        </svg>

    )
}

export default ChevronRight